import { useState } from 'react';
import { getBreadCrumbSchema } from '../../constants/componentStaticData';
import { DOMAIN_PREFIX } from '../../constants/staticPageConstants';
import { Breadcrumb, BREADCRUMB_TYPE } from '../Atoms/BreadCrumb';
import { If } from '../Atoms/Conditionals';
import { UpTick } from '../Icons';
import { Heading, HeadingType } from '../Typography';
import { AuthorCard } from './AuthorCard';
import { DOMAIN_CODE } from './constants';
import { IPAGINATED_AUTHORS_LIST } from './types';
import { getActiveAuthors } from './utils/authorListUtils';

export const AuthorList = ({
  data,
}: {
  data: IPAGINATED_AUTHORS_LIST;
}): JSX.Element => {
  const [authorList, setAuthorList] = useState(data);
  const [page, setPage] = useState(1);

  const BREADCRUMB: BREADCRUMB_TYPE[] = [
    { title: 'Home', link: '/' },
    { title: 'Authors', link: '' },
  ];

  const handleViewMore = async () => {
    setPage((prevPage) => prevPage + 1);
    try {
      const dataRes = await getActiveAuthors(DOMAIN_CODE, page + 1);
      setAuthorList({
        count: authorList.count,
        next: dataRes.next,
        previous: dataRes.previous,
        results: [...authorList.results, ...dataRes.results],
      });
    } catch (err) {
      console.log('Error fetching all authors', err);
    }
  };
  return (
    <>
      <Breadcrumb dataSet={BREADCRUMB} />
      <Heading
        content={`${DOMAIN_PREFIX[DOMAIN_CODE]?.name} Authors`}
        variant={HeadingType.h1}
        className="text-s-40 mt-8 pb-5 sm:mt-4 sm:pb-4 sm:text-s-28"
      />
      <hr />

      <div className="mt-7 sm:mt-5">
        {authorList.results.map((author) => {
          return (
            <AuthorCard
              key={author.name}
              name={author.name}
              designation={author.designation}
              authorImg={author.image_url}
              description={author.description}
              linkedin={author.linkedin_url}
              facebook={author.facebook_url}
              twitter={author.twitter_url}
              slug={author.slug}
              showHeading={false}
            />
          );
        })}
      </div>

      <If condition={!!data.next}>
        <div
          className="text-base font-semibold flex text-blue-350 px-6 py-4 mb-4 justify-center items-center gap-2 cursor-pointer"
          onClick={handleViewMore}
        >
          View more <UpTick colorCode="#1478fa" />
        </div>
      </If>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(getBreadCrumbSchema(BREADCRUMB)),
        }}
      ></script>
    </>
  );
};
